export type FocalPoint = {
  top?: number;
  left?: number;
};

export enum ContentType {
  COURSE = "COURSE",
  CHAPTER = "CHAPTER",
  SECTION = "SECTION",
  ACTIVITY = "ACTIVITY",
  PAGE = "PAGE",
}

export enum DynamicActivityConfigurationType {
  TRAINER = "TRAINER",
  CHAPTER_TEST = "CHAPTER_TEST",
  PRACTICE_EXAM = "PRACTICE_EXAM",
}

export interface IDataObject {
  contentId?: string;
  isDemo?: boolean;
}

export interface AuthorImageProps {
  url: string;
  description?: string;
  focalPoint?: FocalPoint;
}

/**
 * @deprecated Use a type based on a Zod schema instead
 */
export interface IContent {
  data?: IDataObject;
  children: IContent[];
  id: string;
  title: string;
  sequence: number;
  type: ContentType;
  visible: boolean;
  image?: AuthorImageProps;
  summary?: string;
  isDemo?: boolean;
}
